<div class="modal-container">
  <h1 i18n>Copy this template</h1>
  <h3 i18n>Enter a title for the new template.</h3>
  <input name="password" id="password" type="text" [formControl]="titleInput" placeholder="Enter your title here" i18n-placeholder />
  <section class="buttons">
    <button class="close-button" (click)="closeModal()" i18n>Cancel</button>
    <button class="submit-button" (click)="submit()" i18n>Submit</button>
  </section>
</div>
